<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="personal-details">
                <h4 class="personal-details-title">Add Product Group</h4>
                <div [formGroup]="form">
                    <div class="form-group">
                        <label>Group Name</label>
                        <input formControlName="name" type="text" class="form-control">
                        <span class="err" *ngIf="form.get('name').invalid && formSubmit">group name required</span>
                    </div>
                    <div class="form-group">
                        <label>Description</label>
                        <textarea formControlName="description" class="form-control" name="" id="" cols="30" rows="3"></textarea>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" (click)="addProductMasterGroup()" class="btn btn-primary">Add Group</button>
                </div>
            </div>
        </div>
    </div>
</div>